import request from "../request"
import qs from "qs";


export function changePassword(data) {
  return request.post({
    url: "/security/api/user/modpas",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}
export function changeMobile(data) {
  return request.post({
    url: "/security-auth/changeMobile",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}
export function getPersonalInformation() {
  return request.get({
    url: "/auth/one"
  })
}
export function submitEnterpriseCertification(data) {
  return request.post({
    url: "/auth/saveorupdate",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}
export function submitPolitCertification(data) {
  return request.post({
    url: "/fly_auth/saveorupdate",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}
export function getEnterpriseCertificationDataById(params) {
  return request.get({
    url: "/auth/details",
    params: params
  })
}
export function getPolitCertificationDataById(params) {
  return request.get({
    url: "/fly_auth/details",
    params: params
  })
}
// export function getRelevanceAircraftData() {
//   return request.get({
//     url: "/fly-car/allflys"
//   })
// }
// export function getSubordinateCompanyOptions() {
//   return request.get({
//     url: "/fly-car/all_comp"
//   })
// }

// export function editFacilityType(data) {
//   return request.post({
//     url: "/facility_type/saveorupdate",
//     data: qs.stringify(data),
//     headers: {
//       "Content-Type": "application/x-www-form-urlencoded"
//     }
//   })
// }

// export function deleteGroundResourcesData(params) {
//     return request.delete({
//       url: "/ground_resource/del",
//       params: params
//     })
// }

// export function getGroundResourcesTypeOptions() {
//   return request.get({
//     url: "/ground_resource_type/all"
//   })
// }

